import React from "react";
const Users: React.FC = () => {
  return (
      <div>User Screen</div>
  );
};

export default Users;
